import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";

export const MOST_COPIED_QUERY_KEY = ["traders", "most-copied"] as const;

export interface MostCopiedTrader {
  id: string;
  username: string;
  profile_image: string;
  pnl: string;
  volume: string;
  markets_traded: number;
  num_trades: number;
  wallet_address?: string;
  address?: string;
  copiers_count?: number;
}

export function useMostCopiedQuery() {
  const { isLoggedIn, isReady } = useAuth();

  return useQuery<MostCopiedTrader[]>({
    queryKey: MOST_COPIED_QUERY_KEY,
    queryFn: async () => {
      const res = await fetch("/api/traders/most-copied");
      if (!res.ok) throw new Error(`${res.status}`);
      const data = await res.json();
      return data.traders || [];
    },
    enabled: isReady && isLoggedIn,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
  });
}
